import { MasterHomCreateProfileComponent } from "./master-create-profile/master-home-create-profile.component";
import { Routes } from '@angular/router';
import { MasterHomeComponent } from './master-home/master-home.component';
import { SingleResolver } from '@app/core/resolvers';
import { CriarGruposDeInvestimentoComponent } from './criar-grupos-de-investimento/criar-grupos-de-investimento.component';
import { EditarGrupoDeInvestimentoComponent } from './editar-grupo-de-investimento/editar-grupo-de-investimento.component';
import { ClienteGrupoInvestimentoComponent } from "./master-cliente/cliente-grupo-investimento/cliente-grupo-investimento.component";
import { MasterClientePerfilAcessoComponent } from "./master-cliente/cliente-perfil-acesso/master-cliente-perfil-acesso.component";
import { MasterMasterComponent } from "./master/master-master.component";
/**
 * Write your custom routes here
 * This file will not be deleted or overwritten by Palmyra Generator
 */
export const customRoutes: Routes = [
  {
    path: 'criar-perfil',
    component: MasterHomCreateProfileComponent
  },
  {
    path: 'master-home/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent
  },
  {
    path: 'master-home',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent
  },
  {
    path: 'backoffice/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent
  },
  {
    path: 'master_backoffice',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent
  }
];
